__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/a4a8293d244bb38c40ba57c72c5d1cf71e8cec4ac042a66847e6c9a2/";